import { render, staticRenderFns } from "./NotProvideData.vue?vue&type=template&id=f074e226&scoped=true&"
import script from "./NotProvideData.vue?vue&type=script&lang=js&"
export * from "./NotProvideData.vue?vue&type=script&lang=js&"
import style0 from "./NotProvideData.vue?vue&type=style&index=0&id=f074e226&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f074e226",
  null
  
)

export default component.exports